import React from 'react';
import { useDispatch } from 'react-redux';
import { filterDeliveryDonwload } from '../../actions/deliveryNotes';

import moment from 'moment';

export const BtnDeliveryNotes = (props) => {

    const dispatch = useDispatch();
    const date = moment();
    let dateWeek = moment();
    const intervalMovement = window.APP_CONFIG.daymovement;
    dateWeek = dateWeek.subtract(intervalMovement, "days");

    const deliverynNotes = {
        store_id: props.store,
        sdate: '',
        edate: '',
        narticle: '',
        ean: '',
        sscc: '',
        ordercode: '',
        deliverynote: props.delivery,
        providercode: '',
    }

    const handleClick = () => {
        dispatch(filterDeliveryDonwload(deliverynNotes));
    }

    return (
        <button className="btn btn_link" props={props} onClick={handleClick}>
           { props.delivery}
        </button>
    )
}
